import usePersistedState from '@hooks/usePersistedState';
import React, { createContext, useCallback, useState, useMemo, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import { isBrowser } from '@utils/isBrowser';
import { logoutWarranty } from '@utils/auth';
import { WARRANTY_PAGE_URL, getWarrantyPageRoute } from '@utils/routeConstants';
import { getCsrfCookie } from 'services/api/auth';

type ContextValue = {
  isLoggedIn: boolean;
  handleLogout: () => void;
  isWarranty: boolean;
};

const WarrantyAuthContext: React.Context<ContextValue> = createContext<ContextValue>({
  isLoggedIn: false,
  handleLogout: () => null,
  isWarranty: false,
});

export default function WarrantyAuthController({ children }: { children: React.ReactNode }) {
  const [authData] = usePersistedState('w-auth', null);
  const [isLoggedIn, setLoggedIn] = useState(Boolean(authData));
  const [isWarranty, setIsWarranty] = useState(false);
  const router = useRouter();

  const toHomeLoginpage = useCallback(() => {
    if (isBrowser) window.location.href = getWarrantyPageRoute('dang-nhap');
    else router.push(getWarrantyPageRoute('dang-nhap'));
  }, []);

  const handleLogout = useCallback(() => {
    setLoggedIn(false);
    logoutWarranty();
    toHomeLoginpage();
  }, []);

  useEffect(() => {
    if (router.asPath.includes('hau-mai')) {
      getCsrfCookie();
    }
    setIsWarranty(window.location.href.indexOf(WARRANTY_PAGE_URL) > -1);
  }, []);

  useEffect(() => {
    setIsWarranty(window.location.href.indexOf(WARRANTY_PAGE_URL) > -1);
  }, [router.pathname]);

  const context: ContextValue = useMemo(
    () => ({
      isLoggedIn,
      handleLogout,
      isWarranty,
    }),
    [isLoggedIn, handleLogout, isWarranty],
  );

  return <WarrantyAuthContext.Provider value={context}>{children}</WarrantyAuthContext.Provider>;
}

export function useWarrantyAuth(): ContextValue {
  return useContext<ContextValue>(WarrantyAuthContext);
}
